import { useNavigate } from "react-router-dom";
import { useAuthContext } from "./useAuthContext";

const useFetch = () => {
  const navigate = useNavigate();
  const { dispatch } = useAuthContext();

  const fetchData = async (endpoint, method = "GET", body, headers = {}) => {
    const token = localStorage.getItem("token");

    const config = {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...headers,
      },
    };

    if (body) {
      config.body = JSON.stringify(body);
    }

    const url = `${process.env.REACT_APP_BACKEND_URL}${endpoint}`;

    try {
      const response = await fetch(url, config);

      if (response.status === 401) {
        localStorage.removeItem("token");
        dispatch({ type: "LOGOUT" });
        return;
      }

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Er is iets misgegaan");
      }

      return await response.json();
    } catch (err) {
      console.error("Fetch error:", err.message);
    }
  };

  return fetchData;
};

export default useFetch;
